import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';

import { FoerderartService } from '../../../services/facetten/instance/foerderart.service';

import { CheckboxFacetteComponent } from '../../checkbox-facette/checkbox-facette.component';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-foerderart-facette',
  templateUrl: './foerderart-facette.component.html',
  imports: [BasisFacetteComponent, CommonModule, CheckboxFacetteComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FoerderartFacetteComponent {
  facettenService = inject(FoerderartService);
  loaderService = inject(LoaderService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$();

  public updateSelectedIds(selectedItems: FilterSelectItem[]): void {
    const selectedIds = selectedItems.map((item) => item.key);
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
